var map = {
	"./": 539,
	"./App": 591,
	"./App.tsx": 591,
	"./Routes": 1141,
	"./Routes.tsx": 1141,
	"./assets/fonts/Inter-Medium.ttf": 1946,
	"./assets/fonts/Inter-SemiBold.ttf": 1947,
	"./assets/fonts/fonts.css": 965,
	"./assets/images/spinner.svg": 1948,
	"./chainAssets/assets-map": 224,
	"./chainAssets/assets-map.json": 224,
	"./chainAssets/bsc-assets": 624,
	"./chainAssets/bsc-assets.json": 624,
	"./chainAssets/bsc-test-assets": 625,
	"./chainAssets/bsc-test-assets.json": 625,
	"./chainAssets/eth-assets": 622,
	"./chainAssets/eth-assets.json": 622,
	"./chainAssets/eth-test-assets": 623,
	"./chainAssets/eth-test-assets.json": 623,
	"./components/CopyAddress/CopyAddress": 439,
	"./components/CopyAddress/CopyAddress.tsx": 439,
	"./components/DialogModal": 86,
	"./components/DialogModal/": 86,
	"./components/DialogModal/DialogActionsModal": 237,
	"./components/DialogModal/DialogActionsModal.tsx": 237,
	"./components/DialogModal/DialogModal": 568,
	"./components/DialogModal/DialogModal.tsx": 568,
	"./components/DialogModal/index": 86,
	"./components/DialogModal/index.ts": 86,
	"./components/Dialogs/AddCustomTokenDialog": 686,
	"./components/Dialogs/AddCustomTokenDialog.tsx": 686,
	"./components/Dialogs/AddTokenDialog": 683,
	"./components/Dialogs/AddTokenDialog.tsx": 683,
	"./components/Dialogs/ConfirmAddTokenDialog": 687,
	"./components/Dialogs/ConfirmAddTokenDialog.tsx": 687,
	"./components/Dialogs/ImportAccountDialog": 682,
	"./components/Dialogs/ImportAccountDialog.tsx": 682,
	"./components/Dialogs/MigrationRequestDialog": 431,
	"./components/Dialogs/MigrationRequestDialog.tsx": 431,
	"./components/Dialogs/MigrationVerifyDialog": 681,
	"./components/Dialogs/MigrationVerifyDialog.tsx": 681,
	"./components/Dialogs/NFTSelectDialog": 1142,
	"./components/Dialogs/NFTSelectDialog.tsx": 1142,
	"./components/Dialogs/NFTSendConfirmDialog": 689,
	"./components/Dialogs/NFTSendConfirmDialog.tsx": 689,
	"./components/Dialogs/NFTSendDialog": 690,
	"./components/Dialogs/NFTSendDialog.tsx": 690,
	"./components/Dialogs/NFTsList": 688,
	"./components/Dialogs/NFTsList.tsx": 688,
	"./components/Dialogs/PopupLoginDialog": 691,
	"./components/Dialogs/PopupLoginDialog.tsx": 691,
	"./components/Dialogs/ReceiveDialog": 324,
	"./components/Dialogs/ReceiveDialog.tsx": 324,
	"./components/Dialogs/RemoveTokenDialog": 692,
	"./components/Dialogs/RemoveTokenDialog.tsx": 692,
	"./components/Dialogs/SaveShareDialog": 327,
	"./components/Dialogs/SaveShareDialog.tsx": 327,
	"./components/Dialogs/SetRecoveryPassword": 695,
	"./components/Dialogs/SetRecoveryPassword.tsx": 695,
	"./components/Dialogs/ShowSeedPhrase": 696,
	"./components/Dialogs/ShowSeedPhrase.tsx": 696,
	"./components/Dialogs/StatusDialog": 668,
	"./components/Dialogs/StatusDialog.tsx": 668,
	"./components/Dialogs/TransferConfirmDialog": 195,
	"./components/Dialogs/TransferConfirmDialog.tsx": 195,
	"./components/Footer/Footer": 595,
	"./components/Footer/Footer.tsx": 595,
	"./components/Header": 268,
	"./components/Header/": 268,
	"./components/Header/index": 268,
	"./components/Header/index.tsx": 268,
	"./components/InputField/InputField": 113,
	"./components/InputField/InputField.tsx": 113,
	"./components/LoadingContent": 269,
	"./components/LoadingContent/": 269,
	"./components/LoadingContent/LoadingContent": 570,
	"./components/LoadingContent/LoadingContent.tsx": 570,
	"./components/LoadingContent/index": 269,
	"./components/LoadingContent/index.ts": 269,
	"./components/SelectField/SelectField": 326,
	"./components/SelectField/SelectField.tsx": 326,
	"./components/Social/Social": 418,
	"./components/Social/Social.tsx": 418,
	"./components/TextLogo/TextLogo": 673,
	"./components/TextLogo/TextLogo.tsx": 673,
	"./components/ToastTooltip": 156,
	"./components/ToastTooltip/": 156,
	"./components/ToastTooltip/index": 156,
	"./components/ToastTooltip/index.tsx": 156,
	"./components/TokenLogoWithChain": 231,
	"./components/TokenLogoWithChain/": 231,
	"./components/TokenLogoWithChain/index": 231,
	"./components/TokenLogoWithChain/index.tsx": 231,
	"./components/Transfer": 95,
	"./components/Transfer/": 95,
	"./components/Transfer/index": 95,
	"./components/Transfer/index.tsx": 95,
	"./components/Transfer/useTransferStyles": 698,
	"./components/Transfer/useTransferStyles.ts": 698,
	"./components/Warning/Warning": 441,
	"./components/Warning/Warning.tsx": 441,
	"./constants": 223,
	"./constants.ts": 223,
	"./constants/api": 53,
	"./constants/api.js": 53,
	"./constants/apiNetworks": 621,
	"./constants/apiNetworks.js": 621,
	"./constants/chain": 699,
	"./constants/chain.js": 699,
	"./constants/netEnums": 14,
	"./constants/netEnums.js": 14,
	"./constants/networks": 82,
	"./constants/networks.js": 82,
	"./constants/regex": 196,
	"./constants/regex.js": 196,
	"./contracts/CloverBridge": 571,
	"./contracts/CloverBridge.json": 571,
	"./contracts/CloverToken": 874,
	"./contracts/CloverToken.json": 874,
	"./controllers/AccountTracker": 633,
	"./controllers/AccountTracker.js": 633,
	"./controllers/AssetsContractController": 634,
	"./controllers/AssetsContractController.js": 634,
	"./controllers/AssetsController": 635,
	"./controllers/AssetsController.js": 635,
	"./controllers/AssetsDetectionController": 636,
	"./controllers/AssetsDetectionController.js": 636,
	"./controllers/CloverController": 632,
	"./controllers/CloverController.js": 632,
	"./controllers/CloverKeyring": 653,
	"./controllers/CloverKeyring.js": 653,
	"./controllers/CurrencyController": 637,
	"./controllers/CurrencyController.js": 637,
	"./controllers/DecryptMessageManager": 638,
	"./controllers/DecryptMessageManager.js": 638,
	"./controllers/DetectTokensController": 639,
	"./controllers/DetectTokensController.js": 639,
	"./controllers/EncryptionPublicKeyManager": 641,
	"./controllers/EncryptionPublicKeyManager.js": 641,
	"./controllers/MessageManager": 643,
	"./controllers/MessageManager.js": 643,
	"./controllers/NonceTracker": 655,
	"./controllers/NonceTracker.js": 655,
	"./controllers/PermissionsController": 648,
	"./controllers/PermissionsController.js": 648,
	"./controllers/PersonalMessageManager": 650,
	"./controllers/PersonalMessageManager.js": 650,
	"./controllers/PolkadotMessageManager": 661,
	"./controllers/PolkadotMessageManager.js": 661,
	"./controllers/PolkadotTransactionManager": 662,
	"./controllers/PolkadotTransactionManager.js": 662,
	"./controllers/PreferencesController": 651,
	"./controllers/PreferencesController.js": 651,
	"./controllers/SolanaMessageManager": 660,
	"./controllers/SolanaMessageManager.js": 660,
	"./controllers/TokenRatesController": 652,
	"./controllers/TokenRatesController.js": 652,
	"./controllers/TypedMessageManager": 659,
	"./controllers/TypedMessageManager.js": 659,
	"./controllers/gas/GasFeeController": 642,
	"./controllers/gas/GasFeeController.js": 642,
	"./controllers/gas/gas-util": 370,
	"./controllers/gas/gas-util.js": 370,
	"./controllers/network/NetworkController": 644,
	"./controllers/network/NetworkController.js": 644,
	"./controllers/network/createInfuraClient": 645,
	"./controllers/network/createInfuraClient.js": 645,
	"./controllers/network/createJsonRpcClient": 646,
	"./controllers/network/createJsonRpcClient.js": 646,
	"./controllers/network/createMetamaskMiddleware": 647,
	"./controllers/network/createMetamaskMiddleware.js": 647,
	"./controllers/transactions/PendingTransactionTracker": 656,
	"./controllers/transactions/PendingTransactionTracker.js": 656,
	"./controllers/transactions/TransactionController": 654,
	"./controllers/transactions/TransactionController.js": 654,
	"./controllers/transactions/TransactionStateManager": 657,
	"./controllers/transactions/TransactionStateManager.js": 657,
	"./controllers/transactions/TxGasUtil": 658,
	"./controllers/transactions/TxGasUtil.js": 658,
	"./controllers/transactions/polkadot-sign-txn": 700,
	"./controllers/transactions/polkadot-sign-txn.js": 700,
	"./controllers/transactions/tx-state-history-helper": 371,
	"./controllers/transactions/tx-state-history-helper.js": 371,
	"./controllers/transactions/txUtils": 188,
	"./controllers/transactions/txUtils.js": 188,
	"./controllers/utils/ComposableObservableStore": 522,
	"./controllers/utils/ComposableObservableStore.js": 522,
	"./controllers/utils/cleanErrorStack": 456,
	"./controllers/utils/cleanErrorStack.js": 456,
	"./controllers/utils/createLoggerMiddleware": 663,
	"./controllers/utils/createLoggerMiddleware.js": 663,
	"./controllers/utils/createOriginMiddleware": 664,
	"./controllers/utils/createOriginMiddleware.js": 664,
	"./controllers/utils/methodMiddleware": 429,
	"./controllers/utils/methodMiddleware.js": 429,
	"./controllers/utils/pendingBalanceCalculator": 1143,
	"./controllers/utils/pendingBalanceCalculator.js": 1143,
	"./controllers/utils/restrictedMethods": 649,
	"./controllers/utils/restrictedMethods.js": 649,
	"./controllers/utils/routerStream": 1144,
	"./controllers/utils/routerStream.js": 1144,
	"./controllers/utils/setupMultiplex": 520,
	"./controllers/utils/setupMultiplex.js": 520,
	"./controllers/walletconnect/WalletConnect": 666,
	"./controllers/walletconnect/WalletConnect.js": 666,
	"./controllers/walletconnect/WalletConnectController": 665,
	"./controllers/walletconnect/WalletConnectController.js": 665,
	"./controllers/walletconnect/WalletConnectNoopStorage": 667,
	"./controllers/walletconnect/WalletConnectNoopStorage.js": 667,
	"./dotTypes/dot-types": 627,
	"./dotTypes/dot-types.js": 627,
	"./fonts/Gilroy-Bold.ttf": 1949,
	"./fonts/Gilroy-Medium.ttf": 1950,
	"./fonts/Gilroy-Regular.ttf": 1951,
	"./fonts/Gilroy-SemiBold.ttf": 1952,
	"./handlers/Popup/PopupHandler": 631,
	"./handlers/Popup/PopupHandler.js": 631,
	"./handlers/Popup/PopupWithBcHandler": 428,
	"./handlers/Popup/PopupWithBcHandler.js": 428,
	"./handlers/Popup/StreamWindow": 519,
	"./handlers/Popup/StreamWindow.js": 519,
	"./handlers/Token/TokenHandler": 640,
	"./handlers/Token/TokenHandler.js": 640,
	"./images/networks-logo/avalanche.svg": 916,
	"./images/networks-logo/bifrost.svg": 925,
	"./images/networks-logo/bsc.svg": 775,
	"./images/networks-logo/calamari.svg": 927,
	"./images/networks-logo/chainx.svg": 920,
	"./images/networks-logo/clover.svg": 914,
	"./images/networks-logo/crust.svg": 921,
	"./images/networks-logo/edgeware.svg": 518,
	"./images/networks-logo/ethmainnet.svg": 774,
	"./images/networks-logo/fantom.svg": 776,
	"./images/networks-logo/heco.svg": 777,
	"./images/networks-logo/karura.svg": 922,
	"./images/networks-logo/khala.svg": 924,
	"./images/networks-logo/kilt.svg": 926,
	"./images/networks-logo/kupulu.svg": 919,
	"./images/networks-logo/kusama.svg": 918,
	"./images/networks-logo/matic.svg": 779,
	"./images/networks-logo/moonriver.svg": 781,
	"./images/networks-logo/okt.svg": 780,
	"./images/networks-logo/plasm.svg": 1953,
	"./images/networks-logo/polkadot.svg": 917,
	"./images/networks-logo/sakura.svg": 915,
	"./images/networks-logo/shiden.svg": 923,
	"./images/networks-logo/solana.svg": 929,
	"./images/networks-logo/token_none.svg": 783,
	"./images/networks-logo/trx.svg": 928,
	"./images/networks-logo/unconnect.svg": 782,
	"./images/networks-logo/xdai.svg": 778,
	"./images/tokens/bnb/1INCH.png": 1954,
	"./images/tokens/bnb/ANKR.png": 1955,
	"./images/tokens/bnb/BAKE.png": 1956,
	"./images/tokens/bnb/BCHA.png": 1957,
	"./images/tokens/bnb/BTCST.png": 1958,
	"./images/tokens/bnb/IOTX.png": 1959,
	"./images/tokens/bnb/MIR.png": 1960,
	"./images/tokens/bnb/NEAR.png": 1961,
	"./images/tokens/bnb/ONT.png": 1962,
	"./images/tokens/bnb/PAX.png": 1963,
	"./images/tokens/bnb/PROM.png": 1964,
	"./images/tokens/bnb/REEF.png": 1965,
	"./images/tokens/bnb/SXP.png": 1966,
	"./images/tokens/bnb/TLM.png": 1967,
	"./images/tokens/bnb/WRX.png": 1968,
	"./images/tokens/bnb/XVS.png": 1969,
	"./images/tokens/bnb/ada.png": 1970,
	"./images/tokens/bnb/alpha.png": 1971,
	"./images/tokens/bnb/atom.png": 1972,
	"./images/tokens/bnb/bCFX.png": 1973,
	"./images/tokens/bnb/bat.png": 1974,
	"./images/tokens/bnb/bch.png": 1975,
	"./images/tokens/bnb/bnb.png": 1976,
	"./images/tokens/bnb/btcb.png": 1977,
	"./images/tokens/bnb/busd.png": 1978,
	"./images/tokens/bnb/busdt.png": 1979,
	"./images/tokens/bnb/cake.png": 1980,
	"./images/tokens/bnb/comp.png": 1981,
	"./images/tokens/bnb/dai.png": 1982,
	"./images/tokens/bnb/dodo.png": 1983,
	"./images/tokens/bnb/doge.png": 1984,
	"./images/tokens/bnb/dot.png": 1985,
	"./images/tokens/bnb/eos.png": 1986,
	"./images/tokens/bnb/etc.png": 1987,
	"./images/tokens/bnb/eth.png": 1988,
	"./images/tokens/bnb/link.png": 1989,
	"./images/tokens/bnb/ltc.png": 1990,
	"./images/tokens/bnb/mkr.png": 1991,
	"./images/tokens/bnb/safemoon.png": 1992,
	"./images/tokens/bnb/snx.png": 1993,
	"./images/tokens/bnb/tko.png": 1994,
	"./images/tokens/bnb/trx.png": 1995,
	"./images/tokens/bnb/uni.png": 1996,
	"./images/tokens/bnb/usdc.png": 1997,
	"./images/tokens/bnb/ust.png": 1998,
	"./images/tokens/bnb/xrp.png": 1999,
	"./images/tokens/bnb/xtz.png": 2000,
	"./images/tokens/bnb/yfi.png": 2001,
	"./images/tokens/bnb/zec.png": 2002,
	"./images/tokens/bnb/zil.png": 2003,
	"./images/tokens/eth/1inch.svg": 2004,
	"./images/tokens/eth/CRO.png": 2005,
	"./images/tokens/eth/HUSD.svg": 2006,
	"./images/tokens/eth/NEXO.svg": 2007,
	"./images/tokens/eth/UMA.png": 2008,
	"./images/tokens/eth/balancer.svg": 2009,
	"./images/tokens/eth/bancor.png": 2010,
	"./images/tokens/eth/bat.png": 2011,
	"./images/tokens/eth/bnb.png": 2012,
	"./images/tokens/eth/busd.svg": 2013,
	"./images/tokens/eth/celsius.svg": 2014,
	"./images/tokens/eth/chainlink.png": 2015,
	"./images/tokens/eth/chiliz.png": 2016,
	"./images/tokens/eth/chsb.svg": 2017,
	"./images/tokens/eth/comp.svg": 2018,
	"./images/tokens/eth/ctoken-dai.svg": 2019,
	"./images/tokens/eth/ctoken-eth.svg": 2020,
	"./images/tokens/eth/ctoken-usdc.svg": 2021,
	"./images/tokens/eth/ctoken-usdt.svg": 2022,
	"./images/tokens/eth/ctoken-wbtc.svg": 2023,
	"./images/tokens/eth/dai.svg": 2024,
	"./images/tokens/eth/enj.svg": 2025,
	"./images/tokens/eth/fei-usd.png": 2026,
	"./images/tokens/eth/ftm.svg": 2027,
	"./images/tokens/eth/graphToken.svg": 2028,
	"./images/tokens/eth/hex.svg": 2029,
	"./images/tokens/eth/holotoken.png": 2030,
	"./images/tokens/eth/huobi-btc.png": 2031,
	"./images/tokens/eth/huobi.svg": 2032,
	"./images/tokens/eth/iost.png": 2033,
	"./images/tokens/eth/livepeer.png": 2034,
	"./images/tokens/eth/mkr.svg": 2035,
	"./images/tokens/eth/okb.svg": 2036,
	"./images/tokens/eth/omg.jpg": 2037,
	"./images/tokens/eth/originprotocol.png": 2038,
	"./images/tokens/eth/pax.svg": 2039,
	"./images/tokens/eth/storj.jpg": 2040,
	"./images/tokens/eth/streamr.svg": 2041,
	"./images/tokens/eth/sushi.svg": 2042,
	"./images/tokens/eth/swipe.svg": 2043,
	"./images/tokens/eth/synthetix.svg": 2044,
	"./images/tokens/eth/theta.svg": 2045,
	"./images/tokens/eth/uni.svg": 2046,
	"./images/tokens/eth/usdc.svg": 2047,
	"./images/tokens/eth/usdt.svg": 2048,
	"./images/tokens/eth/ven.svg": 2049,
	"./images/tokens/eth/wbtc.svg": 2050,
	"./images/tokens/eth/yfi.svg": 2051,
	"./images/tokens/eth/zilliqa.svg": 2052,
	"./images/tokens/eth/zrx.svg": 2053,
	"./index": 539,
	"./index.css": 1145,
	"./index.tsx": 539,
	"./modules/Authorization/AuthorizationRoutes": 526,
	"./modules/Authorization/AuthorizationRoutes.tsx": 526,
	"./modules/Authorization/screens": 572,
	"./modules/Authorization/screens/": 572,
	"./modules/Authorization/screens/Login": 493,
	"./modules/Authorization/screens/Login.tsx": 493,
	"./modules/Authorization/screens/index": 572,
	"./modules/Authorization/screens/index.tsx": 572,
	"./modules/Authorization/screens/useLoginStyles": 701,
	"./modules/Authorization/screens/useLoginStyles.ts": 701,
	"./modules/common/RouteConfiguration": 1146,
	"./modules/common/RouteConfiguration.ts": 1146,
	"./modules/common/components/QueryLoading/QueryLoading": 417,
	"./modules/common/components/QueryLoading/QueryLoading.tsx": 417,
	"./modules/common/components/Spinner": 317,
	"./modules/common/components/Spinner/": 317,
	"./modules/common/components/Spinner/Spinner": 589,
	"./modules/common/components/Spinner/Spinner.tsx": 589,
	"./modules/common/components/Spinner/index": 317,
	"./modules/common/components/Spinner/index.ts": 317,
	"./modules/common/components/Spinner/useSpinnerStyles": 594,
	"./modules/common/components/Spinner/useSpinnerStyles.ts": 594,
	"./modules/i18n": 316,
	"./modules/i18n/": 316,
	"./modules/i18n/en-US": 809,
	"./modules/i18n/en-US.json": 809,
	"./modules/i18n/i18nSlice": 619,
	"./modules/i18n/i18nSlice.ts": 619,
	"./modules/i18n/index": 316,
	"./modules/i18n/index.ts": 316,
	"./modules/i18n/intl": 19,
	"./modules/i18n/intl.ts": 19,
	"./modules/i18n/useLocale": 593,
	"./modules/i18n/useLocale.ts": 593,
	"./modules/icons/AccountIcon": 525,
	"./modules/icons/AccountIcon.tsx": 525,
	"./modules/icons/AddIcon": 325,
	"./modules/icons/AddIcon.tsx": 325,
	"./modules/icons/ApproveIcon": 702,
	"./modules/icons/ApproveIcon.tsx": 702,
	"./modules/icons/ArrowDownIcon": 676,
	"./modules/icons/ArrowDownIcon.tsx": 676,
	"./modules/icons/ArrowRightIcon": 438,
	"./modules/icons/ArrowRightIcon.tsx": 438,
	"./modules/icons/CloseIcon": 669,
	"./modules/icons/CloseIcon.tsx": 669,
	"./modules/icons/CollectionIcon": 679,
	"./modules/icons/CollectionIcon.tsx": 679,
	"./modules/icons/CollectionsIcon": 703,
	"./modules/icons/CollectionsIcon.tsx": 703,
	"./modules/icons/CopyIcon": 270,
	"./modules/icons/CopyIcon.tsx": 270,
	"./modules/icons/CorrectIcon": 174,
	"./modules/icons/CorrectIcon.tsx": 174,
	"./modules/icons/CrossIcon": 333,
	"./modules/icons/CrossIcon.tsx": 333,
	"./modules/icons/DeleteIcon": 704,
	"./modules/icons/DeleteIcon.tsx": 704,
	"./modules/icons/DeviceIcon": 705,
	"./modules/icons/DeviceIcon.tsx": 705,
	"./modules/icons/EyeCloseIcon": 432,
	"./modules/icons/EyeCloseIcon.tsx": 432,
	"./modules/icons/EyeIcon": 433,
	"./modules/icons/EyeIcon.tsx": 433,
	"./modules/icons/FailIcon": 365,
	"./modules/icons/FailIcon.tsx": 365,
	"./modules/icons/FailStatusIcon": 671,
	"./modules/icons/FailStatusIcon.tsx": 671,
	"./modules/icons/LinkIcon": 271,
	"./modules/icons/LinkIcon.tsx": 271,
	"./modules/icons/LockIcon": 706,
	"./modules/icons/LockIcon.tsx": 706,
	"./modules/icons/NFTPlaceHolderIcon": 442,
	"./modules/icons/NFTPlaceHolderIcon.tsx": 442,
	"./modules/icons/QuestionMarkIcon": 707,
	"./modules/icons/QuestionMarkIcon.tsx": 707,
	"./modules/icons/ReceiveIcon": 366,
	"./modules/icons/ReceiveIcon.tsx": 366,
	"./modules/icons/RejectIcon": 708,
	"./modules/icons/RejectIcon.tsx": 708,
	"./modules/icons/RemoveIcon": 684,
	"./modules/icons/RemoveIcon.tsx": 684,
	"./modules/icons/ReturnIcon": 430,
	"./modules/icons/ReturnIcon.tsx": 430,
	"./modules/icons/SearchIcon": 685,
	"./modules/icons/SearchIcon.tsx": 685,
	"./modules/icons/SendConfirmIcon": 440,
	"./modules/icons/SendConfirmIcon.tsx": 440,
	"./modules/icons/SendIcon": 293,
	"./modules/icons/SendIcon.tsx": 293,
	"./modules/icons/SettingIcon": 680,
	"./modules/icons/SettingIcon.tsx": 680,
	"./modules/icons/SuccessIcon": 322,
	"./modules/icons/SuccessIcon.tsx": 322,
	"./modules/icons/SuccessStatusIcon": 670,
	"./modules/icons/SuccessStatusIcon.tsx": 670,
	"./modules/icons/TrashIcon": 693,
	"./modules/icons/TrashIcon.tsx": 693,
	"./modules/icons/WalletIcon": 678,
	"./modules/icons/WalletIcon.tsx": 678,
	"./modules/icons/WarningIcon": 694,
	"./modules/icons/WarningIcon.tsx": 694,
	"./modules/icons/loading/ContentLoadingIcon": 697,
	"./modules/icons/loading/ContentLoadingIcon.tsx": 697,
	"./modules/icons/loading/DataLoadingIcon": 238,
	"./modules/icons/loading/DataLoadingIcon.tsx": 238,
	"./modules/icons/loading/LogoLoadingIcon": 443,
	"./modules/icons/loading/LogoLoadingIcon.tsx": 443,
	"./modules/icons/loading/PageLoadingIcon": 1147,
	"./modules/icons/loading/PageLoadingIcon.tsx": 1147,
	"./modules/icons/logo/LogoIcon": 419,
	"./modules/icons/logo/LogoIcon.tsx": 419,
	"./modules/icons/settings/KeyIcon": 709,
	"./modules/icons/settings/KeyIcon.tsx": 709,
	"./modules/icons/settings/PasswordIcon": 710,
	"./modules/icons/settings/PasswordIcon.tsx": 710,
	"./modules/icons/settings/SeedIcon": 711,
	"./modules/icons/settings/SeedIcon.tsx": 711,
	"./modules/icons/settings/SettedIcon": 712,
	"./modules/icons/settings/SettedIcon.tsx": 712,
	"./modules/icons/socialIcon/DiscordIcon": 597,
	"./modules/icons/socialIcon/DiscordIcon.tsx": 597,
	"./modules/icons/socialIcon/DiscordLogoIcon": 437,
	"./modules/icons/socialIcon/DiscordLogoIcon.tsx": 437,
	"./modules/icons/socialIcon/FacebookIcon": 436,
	"./modules/icons/socialIcon/FacebookIcon.tsx": 436,
	"./modules/icons/socialIcon/GoogleIcon": 435,
	"./modules/icons/socialIcon/GoogleIcon.tsx": 435,
	"./modules/icons/socialIcon/MediumIcon": 598,
	"./modules/icons/socialIcon/MediumIcon.tsx": 598,
	"./modules/icons/socialIcon/TelegramIcon": 596,
	"./modules/icons/socialIcon/TelegramIcon.tsx": 596,
	"./modules/icons/socialIcon/TwitterIcon": 318,
	"./modules/icons/socialIcon/TwitterIcon.tsx": 318,
	"./modules/layout/AppBase/AppBase": 592,
	"./modules/layout/AppBase/AppBase.tsx": 592,
	"./modules/theme/mainTheme": 160,
	"./modules/theme/mainTheme.ts": 160,
	"./pages/activityDetail": 409,
	"./pages/activityDetail/": 409,
	"./pages/activityDetail/index": 409,
	"./pages/activityDetail/index.js": 409,
	"./pages/activityDetail/useActivityDetailStyles": 713,
	"./pages/activityDetail/useActivityDetailStyles.ts": 713,
	"./pages/authEnd": 410,
	"./pages/authEnd/": 410,
	"./pages/authEnd/index": 410,
	"./pages/authEnd/index.js": 410,
	"./pages/collectionDetail": 411,
	"./pages/collectionDetail/": 411,
	"./pages/collectionDetail/index": 411,
	"./pages/collectionDetail/index.js": 411,
	"./pages/collectionDetail/useCollectionDetailStyles": 714,
	"./pages/collectionDetail/useCollectionDetailStyles.tsx": 714,
	"./pages/collections": 412,
	"./pages/collections/": 412,
	"./pages/collections/index": 412,
	"./pages/collections/index.js": 412,
	"./pages/collections/useCollectionsStyles": 715,
	"./pages/collections/useCollectionsStyles.tsx": 715,
	"./pages/confirm": 413,
	"./pages/confirm/": 413,
	"./pages/confirm/index": 413,
	"./pages/confirm/index.js": 413,
	"./pages/confirm/useConfirmStyles": 716,
	"./pages/confirm/useConfirmStyles.ts": 716,
	"./pages/homePage": 407,
	"./pages/homePage/": 407,
	"./pages/homePage/MyAccount/MyAccount": 674,
	"./pages/homePage/MyAccount/MyAccount.tsx": 674,
	"./pages/homePage/MyAccount/useMyAccountStyles": 675,
	"./pages/homePage/MyAccount/useMyAccountStyles.tsx": 675,
	"./pages/homePage/MyBalance/MyBalance": 677,
	"./pages/homePage/MyBalance/MyBalance.tsx": 677,
	"./pages/homePage/index": 407,
	"./pages/homePage/index.js": 407,
	"./pages/homePage/useHomeStyles": 672,
	"./pages/homePage/useHomeStyles.ts": 672,
	"./pages/login": 405,
	"./pages/login/": 405,
	"./pages/login/SocialAccount": 434,
	"./pages/login/SocialAccount.tsx": 434,
	"./pages/login/index": 405,
	"./pages/login/index.js": 405,
	"./pages/login/useLoginStyles": 323,
	"./pages/login/useLoginStyles.ts": 323,
	"./pages/popup": 414,
	"./pages/popup/": 414,
	"./pages/popup/index": 414,
	"./pages/popup/index.js": 414,
	"./pages/redirect": 415,
	"./pages/redirect/": 415,
	"./pages/redirect/index": 415,
	"./pages/redirect/index.js": 415,
	"./pages/settings": 416,
	"./pages/settings/": 416,
	"./pages/settings/index": 416,
	"./pages/settings/index.js": 416,
	"./pages/settings/useSettingsStyles": 718,
	"./pages/settings/useSettingsStyles.ts": 718,
	"./pages/transfer/transferCrossChain": 719,
	"./pages/transfer/transferCrossChain.js": 719,
	"./pages/transfer/transferErc20": 720,
	"./pages/transfer/transferErc20.js": 720,
	"./pages/transfer/transferEthFamily": 721,
	"./pages/transfer/transferEthFamily.js": 721,
	"./pages/transfer/transferPolkaFamily": 722,
	"./pages/transfer/transferPolkaFamily.js": 722,
	"./pages/transfer/transferSol": 723,
	"./pages/transfer/transferSol.js": 723,
	"./pages/transfer/transferTrx": 724,
	"./pages/transfer/transferTrx.js": 724,
	"./pages/wallet": 408,
	"./pages/wallet/": 408,
	"./pages/wallet/index": 408,
	"./pages/wallet/index.js": 408,
	"./pages/wallet/useWalletStyles": 725,
	"./pages/wallet/useWalletStyles.ts": 725,
	"./react-app-env.d": 1148,
	"./react-app-env.d.ts": 1148,
	"./reportWebVitals": 726,
	"./reportWebVitals.js": 726,
	"./services/AccountService": 107,
	"./services/AccountService.ts": 107,
	"./services/AssetServcie": 44,
	"./services/AssetServcie.ts": 44,
	"./services/BalanceWatcherServicer": 157,
	"./services/BalanceWatcherServicer.ts": 157,
	"./services/CloverWebManager": 169,
	"./services/CloverWebManager.js": 169,
	"./services/DotApiService": 116,
	"./services/DotApiService.js": 116,
	"./services/FeeService": 142,
	"./services/FeeService.js": 142,
	"./services/LocalstorageService": 61,
	"./services/LocalstorageService.ts": 61,
	"./services/PopupService": 146,
	"./services/PopupService.js": 146,
	"./services/SolanaService": 138,
	"./services/SolanaService.ts": 138,
	"./services/TransactionService": 54,
	"./services/TransactionService.ts": 54,
	"./services/TrxService": 186,
	"./services/TrxService.ts": 186,
	"./services/WalletService": 27,
	"./services/WalletService.ts": 27,
	"./services/backendService": 123,
	"./services/backendService.ts": 123,
	"./services/channelSetupService": 105,
	"./services/channelSetupService.js": 105,
	"./services/eventService": 89,
	"./services/eventService.ts": 89,
	"./services/externalService": 717,
	"./services/externalService.ts": 717,
	"./services/interceptorService": 727,
	"./services/interceptorService.ts": 727,
	"./services/loginService": 51,
	"./services/loginService.ts": 51,
	"./services/logoutService": 130,
	"./services/logoutService.ts": 130,
	"./services/migrationService": 620,
	"./services/migrationService.ts": 620,
	"./services/nftService": 292,
	"./services/nftService.ts": 292,
	"./services/toastService": 206,
	"./services/toastService.js": 206,
	"./services/tokenService": 184,
	"./services/tokenService.ts": 184,
	"./services/web3TxRetryService": 527,
	"./services/web3TxRetryService.ts": 527,
	"./setupTests": 1149,
	"./setupTests.js": 1149,
	"./state": 115,
	"./state/": 115,
	"./state/account/actions": 161,
	"./state/account/actions.ts": 161,
	"./state/account/hooks": 49,
	"./state/account/hooks.ts": 49,
	"./state/account/reducer": 615,
	"./state/account/reducer.ts": 615,
	"./state/account/types": 1208,
	"./state/account/types.ts": 1208,
	"./state/api/actions": 277,
	"./state/api/actions.ts": 277,
	"./state/api/hooks": 1209,
	"./state/api/hooks.ts": 1209,
	"./state/api/reducer": 614,
	"./state/api/reducer.ts": 614,
	"./state/app/actions": 176,
	"./state/app/actions.ts": 176,
	"./state/app/hooks": 68,
	"./state/app/hooks.ts": 68,
	"./state/app/reducer": 616,
	"./state/app/reducer.ts": 616,
	"./state/index": 115,
	"./state/index.ts": 115,
	"./state/popup/actions": 221,
	"./state/popup/actions.ts": 221,
	"./state/popup/hooks": 299,
	"./state/popup/hooks.ts": 299,
	"./state/popup/reducer": 618,
	"./state/popup/reducer.ts": 618,
	"./state/token/types": 1210,
	"./state/token/types.ts": 1210,
	"./state/transaction/actions": 321,
	"./state/transaction/actions.ts": 321,
	"./state/transaction/hooks": 444,
	"./state/transaction/hooks.ts": 444,
	"./state/transaction/reducer": 617,
	"./state/transaction/reducer.ts": 617,
	"./state/transaction/types": 1211,
	"./state/transaction/types.ts": 1211,
	"./state/user/actions": 319,
	"./state/user/actions.ts": 319,
	"./state/user/hooks": 91,
	"./state/user/hooks.ts": 91,
	"./state/user/reducer": 291,
	"./state/user/reducer.ts": 291,
	"./state/user/types": 1212,
	"./state/user/types.ts": 1212,
	"./state/wallet/actions": 187,
	"./state/wallet/actions.ts": 187,
	"./state/wallet/hooks": 1213,
	"./state/wallet/hooks.ts": 1213,
	"./state/wallet/reducer": 600,
	"./state/wallet/reducer.ts": 600,
	"./state/wallet/types": 1214,
	"./state/wallet/types.ts": 1214,
	"./types/bigNum": 124,
	"./types/bigNum.test": 1215,
	"./types/bigNum.test.ts": 1215,
	"./types/bigNum.ts": 124,
	"./typings/qrcode.d": 1216,
	"./typings/qrcode.d.ts": 1216,
	"./utils/AccountUtils": 601,
	"./utils/AccountUtils.ts": 601,
	"./utils/abiDecoder": 455,
	"./utils/abiDecoder.js": 455,
	"./utils/apiUtils": 513,
	"./utils/apiUtils.ts": 513,
	"./utils/contractMetadata": 260,
	"./utils/contractMetadata.js": 260,
	"./utils/conversionUtils": 170,
	"./utils/conversionUtils.js": 170,
	"./utils/crossChain": 111,
	"./utils/crossChain.js": 111,
	"./utils/cryptoUtils": 117,
	"./utils/cryptoUtils.ts": 117,
	"./utils/helper": 72,
	"./utils/helper.js": 72,
	"./utils/httpHelpers": 364,
	"./utils/httpHelpers.js": 364,
	"./utils/numberUtils": 39,
	"./utils/numberUtils.js": 39,
	"./utils/random-id": 168,
	"./utils/random-id.js": 168,
	"./utils/secrets": 810,
	"./utils/secrets.js": 810,
	"./utils/timeUtils": 460,
	"./utils/timeUtils.js": 460,
	"./utils/tokenUtils": 298,
	"./utils/tokenUtils.js": 298,
	"./utils/utils": 56,
	"./utils/utils.js": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1945;